<template>
  
  <div id="password-update-dialog" class="ui mini modal password-update-modal">
    <div class="ui header">
      Alterar Senha
    </div>
    <div class="content">
      <div class="ui form">
        <div v-if="showCurrentPasswordInput" class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Senha atual <span class="red text">*</span></label>
            <input type="password" v-model="currentPassword">
          </div>
        </div>
        <div class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Nova senha <span class="red text">*</span></label>
            <input type="password" v-model="newPassword">
          </div>
        </div>
        <div class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Confirme a nova senha <span class="red text">*</span></label>
            <input type="password" v-model="confirmNewPassword">
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="ui cancel basic button">
        <i class="reply icon"></i>
        Cancelar
      </button>
      <button class="ui blue button" :class="{ disabled: !canConfirm, loading }" 
        @click="onConfirm()">
        <i class="check icon"></i>
        Confirmar
      </button>
    </div>
  </div>

</template>

<script>

  import AuthService from "@/services/auth-service"
  import Message from "@/utils/message"

  export default {
    
    data() {
      return {
        loading: false,
        showCurrentPasswordInput: true,
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: "",
      }
    },

    computed: {

      canConfirm() {
        
        let canConfirm = true

        if (!this.currentPassword || !this.newPassword || !this.confirmNewPassword)
          canConfirm = false

        return canConfirm
      },
    },

    beforeDestroy() {
      $(".password-update-modal").remove()
    },

    methods: {

      show(data) {

        this.loading = false
        this.showCurrentPasswordInput = true
        this.currentPassword = ""
        this.newPassword = ""
        this.confirmNewPassword = ""

        if (data) {

          const { showCurrentPasswordInput, currentPassword } = data
          
          if (typeof showCurrentPasswordInput == "boolean")
            this.showCurrentPasswordInput = showCurrentPasswordInput

          if (currentPassword)
            this.currentPassword = currentPassword  
        }

        $("#password-update-dialog").modal("show")
      },

      hide() {
        $("#password-update-dialog").modal("hide")
      },

      async onConfirm() {

        if (this.newPassword != this.confirmNewPassword) {
          Message.info("Senha não confirmada corretamente")
          return
        }

        this.loading = true

        try {

          await AuthService.changePassword(this.currentPassword, this.newPassword)          

          this.hide()

          Message.success("Senha alterada com sucesso")

          this.$emit("onConfirm")

        } catch (error) {

          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },
    },
  }

</script>

